module.exports = __webpack_public_path__ + "img/vaccine-detail.61a8bf55.svg";